<template>
  <a-config-provider
      :theme="{
      token: {
        colorPrimary: '#ff9f3a'
      }
    }"
  >
    <router-view />
  </a-config-provider>
</template>

<script setup>
</script>